import { Component, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectionActions } from '../../../state/selection/selection.actions'
import { SelectionMode, SelectionType } from '../../../state/selection/selection.state'
import {
    selectSelectionSize,
    selectMode,
    selectSelectionState,
} from '../../../state/selection/selection.selectors'
import { plotDataActions } from 'src/app/state/plot-data/plot-data.actions'
import {
    selectLassoType,
    selectPointOpacity,
    selectPointSize,
} from 'src/app/state/plot-data/plot-data.selectors'
import { Dialog } from '@angular/cdk/dialog'
import { take } from 'rxjs'
import { Subject } from 'rxjs'
import { AddPropertiesDialogComponent } from '../../add-properties-dialog/add-properties-dialog.component'
import { selectLoadedSegObjectPropertyMaps } from 'src/app/state/case/case.selectors'
import { ToasterService } from 'src/app/shared/services/toaster.service'

@Component({
    selector: 'app-selection-manipulation',
    templateUrl: './selection-manipulation.component.html',
    styleUrls: ['./selection-manipulation.component.scss'],
})
export class SelectionManipulationComponent implements OnDestroy {
    SelectionModeEnum = SelectionMode
    loadedSegObjectPropertyMaps$ = this.store.select(selectLoadedSegObjectPropertyMaps)
    selectionSize$ = this.store.select(selectSelectionSize)
    selectionMode$ = this.store.select(selectMode)
    pointSize$ = this.store.select(selectPointSize)
    pointOpacity$ = this.store.select(selectPointOpacity)
    lassoType$ = this.store.select(selectLassoType)
    isUnsupervisedSelection = false
    resolution$ = 6
    lassoType = 'freeform'

    private readonly destroy$ = new Subject<void>()

    constructor(
        private readonly store: Store,
        private readonly dialog: Dialog,
        private readonly toasterService: ToasterService
    ) {
        this.store
            .select(selectSelectionState)
            .pipe()
            .subscribe(state => {
                if (state.type === SelectionType.Unsupervised) {
                    this.isUnsupervisedSelection = true
                } else {
                    this.isUnsupervisedSelection = false
                }
            })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    clearSelection(): void {
        // Reset must clear every segSource bucket (multi-mapping selections).
        this.store.dispatch(selectionActions.clearSelection({ allBuckets: true }))
    }

    setSelectionModeAdd(): void {
        this.store.dispatch(selectionActions.setMode({ mode: SelectionMode.Add }))
    }

    setSelectionModeSubtract(): void {
        this.store.dispatch(selectionActions.setMode({ mode: SelectionMode.Subtract }))
    }

    setPointSize(size: number): void {
        this.store.dispatch(plotDataActions.setPointSize({ size }))
    }

    setPointOpacity(opacity: number): void {
        this.store.dispatch(plotDataActions.setPointOpacity({ opacity }))
    }

    setLassoType(): void {
        this.lassoType$.pipe(take(1)).subscribe(lassoType => {
            this.store.dispatch(
                plotDataActions.setLassoType({
                    lassoType: lassoType === 'freeform' ? 'rectangle' : 'freeform',
                })
            )
        })
    }

    openAddPropertiesDialog(): void {
        this.loadedSegObjectPropertyMaps$.pipe(take(1)).subscribe(loadedMaps => {
            if (loadedMaps.length === 0) {
                this.toasterService.error('Select an intensity map first', 'Error')
                return
            }
            this.dialog.open(AddPropertiesDialogComponent)
        })
    }
}
